define([
    'jquery',
    './helpers/console',
], function ($, console) {
    'use strict';

    var debounce = function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    var add_to_cart_init = function () {
        $(document).off('submit', '.js_form_add_to_cart');
        $(document).on('submit', '.js_form_add_to_cart', function (event) {
            event.preventDefault();

            var $form = $(this),
                url = $form.attr('action'),
                $submit = $form.find('button');

            var data = {
                action: 'add_to_cart',
                product_id: $form.find('[name=product_id]').val() || 0,
                quantity: $form.find('[name=quantity]').val() || 1
            };

            $.ajax({
                beforeSend: function () {
                    $submit.prop('disabled', true);
                    $submit.removeClass('added_to_cart');
                    $submit.addClass('loading');
                },
                url: url,
                method: 'POST',
                cache: false,
                data: data,
                dataType: 'json'
            })
                .done(function (json) {
                    $submit.prop('disabled', false);
                    $submit.removeClass('loading');

                    if (json.result === 'success') {
                        $('.shopping_cart_mini__count').html(json.cart_count);
                        $submit.addClass('added_to_cart');
                    } else {
                        alert(json.message);
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    $submit.prop('disabled', false);
                    $submit.removeClass('loading');

                    alert(textStatus, errorThrown)
                });
        });
    };

    var remove_from_cart_init = function () {
        $(document).off('click', '.js_cart_remove');
        $(document).on('click', '.js_cart_remove', function (event) {
            event.preventDefault();

            var $link = $(this);
            var url = $link.attr('href');
            var product_id = $link.data('product_id');

            var data = {
                action: 'remove_from_cart',
                product_id: product_id || 0,
            };

            $.ajax({
                beforeSend: function () {
                    $link.addClass('loading');
                },
                url: url,
                method: 'POST',
                cache: false,
                data: data,
                dataType: 'json'
            })
                .done(function (json, textStatus, jqXHR) {
                    $link.removeClass('loading');

                    if (json.result === 'success') {
                        var $row = $link.parents('.order_cart_resp__row_item');
                        var $spacer = $row.find('.order_cart_resp__spacer');
                        var $inner = $row.find('.order_cart_resp__inner');

                        $spacer.addClass('to_be_removed');
                        $spacer.height($inner.height());

                        $inner.fadeOut(300, function () {
                            $spacer.slideUp(300, function () {
                                $row.remove();
                                $('.order_cart_wrap').html(json.output_cart);
                                $('.order_totals__wrap').html(json.output_totals);

                                if (json.cart_count === 0) {
                                    $('.order_form__wrap').empty();
                                }
                            });
                        });
                    } else {
                        alert(json.message);
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    $link.removeClass('loading');
                    alert(textStatus, errorThrown);
                });
        });
    };

    var update_cart_init = function() {
        var jqxhr = {abort: function () {}};

        var onChange = debounce(function(event) {
            event.preventDefault();

            var $input = $(this),
                url = $input.data('url'),
                product_id = $input.prop('name'),
                quantity = $input.val() || 0;

            var data = {
                action: 'update_cart',
                product_id: product_id || 0,
                quantity: quantity
            };

            if (jqxhr) {
                jqxhr.abort();
            }

            jqxhr = $.ajax({
                beforeSend: function() {
                    $input.prop('disabled', true);
                    $('.order_cart_wrap').css('opacity', '0.4');
                },
                url: url,
                method: 'POST',
                cache: false,
                data: data,
                dataType: 'json'
            })
                .done(function(json) {
                    $input.prop('disabled', false);
                    if (json.result === 'success') {
                        $('.order_cart_wrap').css('opacity', '1');
                        $('.order_cart_wrap').html(json.output_cart);
                        $('.order_totals__wrap').html(json.output_totals);

                        if (json.cart_count === 0) {
                            $('.order_form__wrap').empty();
                        }
                    } else {
                        alert(json.message);
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    $input.prop('disabled', false);
                    alert(textStatus, errorThrown)
                }).always(function() {
                    jqxhr = undefined;
                });
        }, 250);

        $(document).off('change', '.js_cart_update');
        $(document).on('change', '.js_cart_update', onChange);

        $(document).off('focus', '.js_cart_update');
        $(document).on('focus', '.js_cart_update', function() {
            var save_this = $(this);
            window.setTimeout (function(){
                save_this.select();
            },100);
        });
    };

    var init = function () {
        add_to_cart_init();
        remove_from_cart_init();
        update_cart_init();
    };

    return {
        init: init
    };
});
